import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import DefaultLoading from "../../../../components/DefaultLoading";
import style from "./style.module.css"
import ReactToPrint from "react-to-print"
const SingleResult = () => {
    const { _id } = useParams()
    console.log(_id)
    const [isLoading, setIsLoading] = useState(true)
    const [resultData, setResultData] = useState({})
    const [marksScored, setMarksScored] = useState(0)
    const [totalMarksScored, setTotalMarksScored] = useState(0)

    const pdfRef = useRef();
    useEffect(() => {
        axios.get(`/getResult/${_id}`)
            .then(res => {
                console.log(res)
                setResultData(res.data.data)
                var calculatedMarksScored = 0;
                var calculatedTotalMarksScored = 0
                for (let i = 0; i < res.data.data.exams.length; i++) {
                    const exam = res.data.data.exams[i];
                    calculatedMarksScored = calculatedMarksScored + +exam.total_marks_scored;
                    calculatedTotalMarksScored = calculatedTotalMarksScored + +exam.exam_data[0].totalMarks;
                    setMarksScored(calculatedMarksScored)
                    setTotalMarksScored(calculatedTotalMarksScored)
                }
                setIsLoading(false)

            })
            .catch(err => {
                console.log(err)
                console.log(err.response)
                setIsLoading(false)

            })
    }, [_id])
    return (
        <div className={style.mainDiv}>
            <h2 className={style.screenHeading}>Result</h2>
            {
                isLoading
                    ?
                    <DefaultLoading />
                    :
                    <>
                        <div ref={pdfRef} className={style.printDiv}>
                            <p className={style.StudentName}>{resultData.student_data[0].name}</p>
                            <p className={style.className}>{resultData.class_data[0].name}</p>
                            <p className={style.examinationName}>{resultData.examination_group_data[0].name}</p>
                            <p className={style.totalMarksScored}>Total marks scored : {marksScored}/{totalMarksScored}</p>
                            {
                                resultData.exams.length > 0
                                    ?
                                    <div className={style.examsWrapper}>
                                        <div className={style.examsHeaderWrapper}>
                                            <p className={style.tableHeader}>Sr No.</p>
                                            <p className={style.tableHeader}>Subject</p>
                                            <p className={style.tableHeader}>Marks Scored</p>
                                            <p className={style.tableHeader}>Total Marks</p>
                                        </div>
                                        {
                                            resultData.exams.map((exam, index) => {

                                                return (
                                                    <div key={index} className={style.examsBody}>

                                                        <p className={style.tableBody}>{index + 1}</p>
                                                        <p className={style.tableBody}>{exam.exam_data[0].subjectName}</p>
                                                        <p className={style.tableBody}>{exam.total_marks_scored}</p>
                                                        <p className={style.tableBody}>{exam.exam_data[0].totalMarks}</p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    <>
                                    </>
                            }
                        </div>
                        <div className={style.printWrapper}>
                            <ReactToPrint
                                trigger={() => <button className={style.printButton}>Print</button>}
                                content={() => pdfRef.current}
                            />
                        </div>
                    </>
            }
        </div>
    )
}

export default SingleResult;